import React from 'react';
import ReferredOrdersContainer from '@src/containers/Referral/ReferredOrders';

const ReferredOrders = () => <ReferredOrdersContainer />;

export default ReferredOrders;
